import { TextField } from "@mui/material";
import { useState } from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import RemarkMathPlugin from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const DisplayFromFHIRMarkdown = ({ markdown }) => {
  if (markdown) {
    if (Array.isArray(markdown) || typeof markdown !== "string") {
      return <>[ERROR: Markdown data not interpretable.]</>;
    }
    try {
      let markdownCorrected = markdown?.replaceAll("\n", "<br/>");
      if (markdownCorrected.substring(0, 42) === "<div xmlns=\"http://www.w3.org/1999/xhtml\">" && markdownCorrected.substring(markdownCorrected.length - 6) === "</div>") {
        markdownCorrected = markdownCorrected.substring(42, markdownCorrected.length - 6);
      }
      return <span className={!markdown.includes("<br/>") ? "nolinebreak" : ""}>
        <ReactMarkdown children={markdownCorrected} remarkPlugins={[remarkGfm, RemarkMathPlugin]}
          rehypePlugins={[rehypeRaw, rehypeKatex]} />
      </span>
    } catch (e) {
      return <>[ERROR: Problem with the markdown format. {e}] {markdown}</>;
    }

  } else {
    return <></>
  }
}

const MarkdownEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  if (startCollapsedState) {
    return <div>
      <b>{fieldLabel}: </b>
      {startingValue && <div style={{ marginLeft: "24px" }}>
        <DisplayFromFHIRMarkdown markdown={startingValue} />
        <br /></div>}
      &nbsp;&nbsp;
      <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
    </div>
  } else {
    return <div>
      <TextField style={{ width: "100%", marginTop: "12px" }} multiline
        className="inputField" type='text' label={fieldLabel} size="small" variant='outlined'
        value={startingValue || ""}
        onChange={(e) => {
          setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value } });
        }} />
      <p>Surround text with ** for <b>BOLD</b> or * for <i>italics</i></p>
      {startingValue && <div style={{ marginLeft: "24px" }}>
        <span>
          <b>{fieldLabel} will display as: </b> {(startingValue && (startingValue.includes("\n") || startingValue.includes("<br"))) && <br />}
          <DisplayFromFHIRMarkdown markdown={startingValue} />
        </span></div>}
    </div>
  }
};

export default MarkdownEntry;
export { DisplayFromFHIRMarkdown };